import React, { useEffect, useRef, useState } from 'react';
import mermaid from 'mermaid';

mermaid.initialize({
  startOnLoad: false,
  theme: 'base',
  themeVariables: {
    fontFamily: 'system-ui, sans-serif',
    fontSize: '12px',
    primaryColor: '#e0e7ff',
    primaryTextColor: '#3730a3',
    primaryBorderColor: '#6366f1',
    lineColor: '#9ca3af',
    secondaryColor: '#f0f9ff',
    tertiaryColor: '#faf5ff',
    nodeBorder: '#6366f1',
    clusterBkg: '#f9fafb',
    clusterBorder: '#e5e7eb',
  },
  securityLevel: 'loose',
  flowchart: {
    curve: 'cardinal',
    padding: 8,
    nodeSpacing: 30,
    rankSpacing: 30,
    useCFS: true,
    htmlLabels: true,
  },
});

let idCounter = 0;

const Mermaid = ({ chart }) => {
  const containerRef = useRef(null);
  const [svg, setSvg] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const id = `mermaid-${idCounter++}`;
    mermaid.render(id, chart).then((result) => {
      let svgText = result.svg;
      
      // Match viewBox to determine diagram proportions
      const viewBoxMatch = svgText.match(/viewBox="([^"]+)"/);
      if (viewBoxMatch) {
        const [, viewBox] = viewBoxMatch;
        const [, , width] = viewBox.split(/\s+/).map(Number);
        
        // Strip out native width/height attributes
        svgText = svgText.replace(/width="[^"]+"/, '');
        svgText = svgText.replace(/height="[^"]+"/, '');
        
        // Set dynamic style: narrower diagrams shouldn't scale up too much, wider ones shouldn't scale down too much.
        const widthCap = Math.min(width, 450);
        svgText = svgText.replace(/<svg /, `<svg style="width: 100%; max-width: ${widthCap}px; height: auto;" `);
      }
      
      svgText = svgText.replace(/<style>/, '<style>text{font-size:12px!important;}.nodeLabel,.edgeLabel{font-size:12px!important;}</style><style>');
      setSvg(svgText);
      setError('');
    }).catch((err) => {
      setError(err.message || 'Failed to render diagram');
    });
  }, [chart]);

  if (error) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-sm text-red-600">
        Diagram error: {error}
      </div>
    );
  }

  return (
    <div
      ref={containerRef}
      className="mermaid-container flex justify-center overflow-x-auto"
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
};

export default Mermaid;
